import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponseModel } from '../../models/base/api-response.model';
import { BaseService } from '../../templates/services/base-service.template';
import { ApiVisa } from '../../models/base/apivisa.model';
import { Core2Config } from '../../utils/core2-config';
import { getHttpHeader } from '../../utils/http-header.factory';
import { SettlementRequestContainerModel } from '../../models/settlement-request/settlement-request-container.model';

@Injectable({
  providedIn: 'root'
})
export class SettlementRequestService implements BaseService {

  public apiUrl: string = Core2Config.TENANT_DOMAIN_URL_PREFIX;
  public credit: string = this.apiUrl + 'pgw/ambank-credit-settlement/req';
  public debit: string = this.apiUrl + 'pgw/ambank-debit-settlement/req';

  constructor(protected readonly http: HttpClient) {}

  public post(
    data: { amount: string, paymentDescription: string, settlementChannelCode: string, paymentCycle: string, reportDate: string },
    { tenantCode, api_domain_url, jwt_secret }: ApiVisa,
    action: 'credit' | 'debit' = 'credit',
  ): Observable<ApiResponseModel<SettlementRequestContainerModel>>
  {
    return this.http.post<ApiResponseModel<SettlementRequestContainerModel>>(`${ api_domain_url }${ this[action] }/${ tenantCode }`, data, getHttpHeader(jwt_secret, tenantCode));
  }
}
